import React, { useState, useEffect } from 'react';
import { Col, Divider, Menu, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import { Link, useParams } from 'react-router-dom';
import LoadingSpinner from '../../components/shared/components/LoadingSpinner';
import Title from 'antd/es/typography/Title';
import { getCommunityResource } from '../../services/communityService';
import ActionHeader from '../../components/Common/ActionHeader';
import EditCommunityResource from './components/EditCommunityResource';
import DeleteWarningModal from '../../components/Common/DeleteWarningModal';

const CommunityResourcePage = () => {
  const [communityResource, setCommunityResource] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const { id } = useParams();

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>
        Edit
      </Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const fetchData = async () => {
    setIsLoading(true);
    setStatus(null);
    await getCommunityResource({ _id: id })
      .then((response) => {
        if (response.data) {
          setCommunityResource(response?.data);
        } else {
          throw Error('This community resource does not exist!');
        }
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <ActionHeader
            title={'Community event: ' + communityResource.title}
            actionMenu={actionMenu}
          />
          <Divider />
          <section>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Topic Index:</Col>
              <Col span={16}>
                <Text strong>{communityResource.topicIndex}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Sub Index:</Col>
              <Col span={16}>
                <Text strong>{communityResource.subIndex}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Title:</Col>
              <Col span={16}>
                <Text strong>{communityResource.title}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Title:</Col>
              <Col span={16}>
                <Text strong>{communityResource.description}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Topic:</Col>
              <Col span={16}>
                <Text strong>{communityResource.topic}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Link:</Col>
              <Col span={16}>
                <Text strong>{communityResource.link}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Community:</Col>
              <Col span={16}>
                <Text>
                  <Link
                    to={`community/${communityResource?.communityObjectId}`}>
                    {communityResource?.communityObjectId}
                  </Link>
                </Text>
              </Col>
            </Row>
          </section>
        </div>
      )}
      <EditCommunityResource
        communityResource={communityResource}
        onCancelModal={() => setIsEditModalVisible(false)}
        isOpen={isEditModalVisible}
      />
      <DeleteWarningModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        deleteLink={`${process.env.REACT_APP_BACKEND_URL}/community/resource/${communityResource?._id}`}
        params={{}}
      />
      {status?.error && (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      )}
    </>
  );
};

export default CommunityResourcePage;
